import { mapValues } from "lodash/fp";
import withDefaultProps from "./withDefaultProps.mjs";
const mapValuesWithKey = mapValues.convert({
  cap: false
});
function handleComponentsProp(components, defaultComponents) {
  return mapValuesWithKey((component, name) => {
    if (typeof component === "object" && component !== null && !component.$$typeof) {
      component = defaultComponents[name] && withDefaultProps(defaultComponents[name], component);
    }
    return component || defaultComponents[name];
  }, {
    ...defaultComponents,
    ...components
  });
}
export { handleComponentsProp as default };